/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This component is used to show generic cards with a banner and a text content
 *
 * It provides four optional slots: badges, media, content and overlay
 *
 * NOTE: if a click handler is provided, it will prevents any default and link will not work.
 *
 * @vue-prop {String} [uid] unique key of this card
 * @vue-prop {String} [link] the URL that this card links to.
 * @vue-prop {String} [media] the URL to the image.
 * @vue-prop {String} [mediaBg] the URL to the background image.
 * @vue-prop {Function} [click] an optional card click handler.
 *
 * @category ui.components
 * @exports Card
 * @component
 */
const __vue_script__ = {
    name: 'Card',

    props: {
        uid: {
            type: String,
            default: null
        },

        link: {
            type: String,
            default: null
        },

        media: {
            type: String,
            default: null
        },

        mediaTitle: {
            type: String,
            default: null
        },

        mediaBg: {
            type: String,
            default: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
        },

        target: {
            type: String,
            default: null
        },

        selected: {
            type: Boolean,
            default: false
        },

        selectable: {
            type: Boolean,
            default: false
        },

        hideMedia: {
            type: Boolean,
            default: false
        },

        showBanner: {
            type: Boolean,
            default: true
        },

        showHeader: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        /**
         * @returns {Boolean} whether the card has an associated action or not
         */
        hasAction() {
            return Boolean(this.$listeners.click || this.link);
        },

        noMedia() {
            return !this.$options.propsData.mediaBg && !this.media && !this.$slots.media;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"card",class:{'has-action': _vm.hasAction, 'no-media': _vm.noMedia, selected: _vm.selected, selectable: _vm.selectable},attrs:{"href":_vm.link,"target":_vm.target,"data-cue":_vm.uid},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"inner"},[(_vm.selectable)?_c('input',{staticClass:"selection",attrs:{"type":"checkbox"},domProps:{"checked":_vm.selected}}):_vm._e(),(_vm.showHeader && _vm.$slots.header)?_c('div',{staticClass:"content-header"},[_vm._t("header")],2):_vm._e(),(_vm.showBanner)?_c('div',{staticClass:"content-banner"},[_vm._t("badges"),(!_vm.hideMedia)?_c('div',{staticClass:"media"},[(_vm.media)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.media),expression:"media"}],key:_vm.media,staticClass:"lazy",attrs:{"alt":_vm.mediaTitle}}):_vm._e(),(_vm.mediaBg)?_c('i',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.mediaBg),expression:"mediaBg",arg:"background-image"}],staticClass:"lazy picture"}):_c('i',{staticClass:"picture"}),_vm._t("media")],2):_vm._e()],2):_vm._e(),_c('div',{staticClass:"content-text"},[_vm._t("content")],2)]),_vm._t("overlay")],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Card.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__